import {
  Button, Card, CardActions, CardHeader, Divider, FormControlLabel, Grid, IconButton, Switch, Typography
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Speech from 'speak-tts';
import { getUser } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import SpeechRecognitionDurumNotu from '../../components/SpeechRecognitionDurumNotu';

const useStyles = makeStyles((theme) => ({
  root: {},
  statsContainer: {
    display: 'flex'
  },
  statsItem: {
    padding: theme.spacing(1),
    flexGrow: 1,
    '&:first-of-type': {
      borderRight: `1px solid ${theme.palette.divider}`
    },
    width: 10
  },
  content: {
    padding: 0
  },
  date: {
    whiteSpace: 'nowrap'
  },
  actions: {
    justifyContent: 'flex-end'
  },
}));

function CustomerActivity({
  className, GununOzeti, checked, changeChecked, today, setToday, todayDisabled, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('today_summary');
  const SessionUser = getUser();
  const UserName = SessionUser.FirstName;

  const handleOku = () => {
    speech
      .init({
        volume: 1,
        lang: 'tr-TR',
        rate: 1,
        pitch: 1,
        // voice:"tr-TR-Standard-B",
        listeners: {
          onvoiceschanged: (voices) => {
          }
        }
      })
      .then((data) => {
        speech
          .speak({
            text: Deger,
            queue: false,
            listeners: {
              onstart: () => {
          
              }
            }
          })
          .then((data) => {
          })
          .catch((e) => {
          });
      })
      .catch((e) => {
      });
  };

  const speech = new Speech();

  // React.useEffect(() => {
  //   return () => {
  //     speech.cancel();
  //   }
  //   // eslint-disable-next-line
  // }, []);


  const EnYakinRandevu = '11-13';
  if (GununOzeti.length === undefined) {
    return null;
  }

  var Deger = `Merhaba, ${UserName} Ben Artemis, ${GununOzeti[0].Ustlenilmemis} üstlenilmemiş iş adedin bulunuyor. En yakın randevu zamanı ${EnYakinRandevu}olarak tespit ettim.İş emrine yönlendirmemi ister misin?`;

  const getKonusmaYazma = () => (
    <div>
      <IconButton color="secondary" onClick={handleOku} aria-label="settings">
        <RecordVoiceOverIcon />
      </IconButton>
      {/* <SpeechRecognitionDurumNotu /> */}
    </div>
  );


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={getKonusmaYazma()}
        title={t('is_plani_ozeti')}
      />

      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('ustlenilmemis')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].Ustlenilmemis}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('ustlenilmis')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].Ustlenilmis}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('yola_cikildi')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].YolaCikildi}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('baslandi')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].Baslandi}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('bayi_talep')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].BayiTalep}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('internet_talep')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].InternetTalep}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('kapali')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].Kapali}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {t('toplam')}
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0].ToplamIs}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <CardActions className={classes.actions}>
        <Grid container spacing={1}>
          <Grid item xs={4} align="left">
            {/* <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={(e) => changeChecked(e.target.checked)}
                  color="primary"
                />
              }
              label={t('Liste')}
            /> */}
          </Grid>
          <Grid item xs={4} align="center">
            {/* <FormControlLabel
              control={
                <Switch
                  checked={today === 1}
                  onChange={(e) =>setToday(e.target.checked ? 1 : 0)}
                  color="primary"
                  disabled={todayDisabled}
                />
              }
              label={today === 0 ? t('Dun') : t('Bugun')}
            /> */}
          </Grid>
          <Grid item xs={4} align="right">
            <Button
              color="primary"
              component={RouterLink}
              size="small"
              to="/overview"
              variant="text"
            >
              {t('Detay')}
              <ArrowForwardIcon className={classes.arrowForwardIcon} />
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

CustomerActivity.propTypes = {
  className: PropTypes.string
};

export default CustomerActivity;
